import { ArrowRight, CircleDot } from "lucide-react";
import { assessmentForClaim, claimsForEvent, events } from "../researchData";
import type { EventRecord } from "../types";

type Props = {
  selected: EventRecord;
  onSelect: (event: EventRecord) => void;
};

export function EventRail({ selected, onSelect }: Props) {
  return (
    <section className="event-section" id="events">
      <div className="section-heading">
        <div>
          <h2>Thirteen seed events</h2>
          <p>The received narrative is decomposed into independently assessable propositions.</p>
        </div>
        <span className="section-count">01 — 13</span>
      </div>
      <div className="event-rail" role="list">
        {events.map((event, index) => {
          const eventClaims = claimsForEvent(event.id);
          const label = eventClaims[0] ? assessmentForClaim(eventClaims[0].id)?.label ?? "unknown" : "unknown";
          return (
            <button
              role="listitem"
              key={event.id}
              className={selected.id === event.id ? "event-stop is-selected" : "event-stop"}
              onClick={() => onSelect(event)}
            >
              <span className="event-number">{String(index + 1).padStart(2, "0")}</span>
              <span className="event-marker"><CircleDot size={15} /></span>
              <span className="event-label">{event.label}</span>
              <span className={`confidence-word confidence-${label}`}>{label.replace("_", " ")}</span>
            </button>
          );
        })}
      </div>
      <button className="event-open" onClick={() => document.getElementById("claims")?.scrollIntoView({ behavior: "smooth" })}>
        Open selected evidence <ArrowRight size={17} />
      </button>
    </section>
  );
}
